import { Context, IContextProvider } from './types';
import { createContext } from './context';
import { IEvent } from '../packages/web/elements-types/src/actions/events.types';

export class ContextProvider implements IContextProvider {
  private _context: Context;

  constructor() {
    this._context = createContext();
  }
  getRole() {
    return this._context.getRole();
  }
  getContext() {
    return this._context;
  }

  getUserId(): string {
    return this._context.getUserId();
  }

  handle(event: IEvent) {
    if (event.type === 'user-profile-changed') {
      this._context.setUser(event.payload);
    }
  }
}
